import { memo } from 'react';
import type { Message } from '../../models/message';
import { MessageMenu } from './message-menu';

interface MessageMenuWrapperProps {
  isOwn?: boolean;
  revoked?: boolean;
  sending?: boolean;
  contextMenu: { mouseX: number; mouseY: number } | null;
  selectedMessage: Message | null;
  onClose: () => void;
}

const MessageMenuWrapper = memo<MessageMenuWrapperProps>(
  ({ isOwn = false, revoked, sending, contextMenu, selectedMessage, onClose }) => {
    if (!contextMenu || !selectedMessage || revoked || sending) return null;
    return <MessageMenu isOwn={isOwn} contextMenu={contextMenu} selMsg={selectedMessage} onClose={onClose} />;
  }
);

MessageMenuWrapper.displayName = 'MessageMenuWrapper';

export { MessageMenuWrapper };
